import { render, staticRenderFns } from "./page-static.vue?vue&type=template&id=75423219&lang=pug&"
import script from "./page-static.vue?vue&type=script&lang=js&"
export * from "./page-static.vue?vue&type=script&lang=js&"
import style0 from "./page-static.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports